import type { VariableType } from "@velizhanin-dev/bot-scenario"
import * as api from "@/entities/bot-builder"
import { draftCache as cache } from "@/entities/bot-builder"
import type { ActionsContext } from "./types"

export function createVariableActions({ enqueue, scenarioId }: ActionsContext) {
	return {
		createVariable: (variable: { name: string; type: VariableType; description?: string }) =>
			enqueue(
				"Не удалось добавить переменную",
				(baseRevision) => api.createVariable(scenarioId, { ...variable, baseRevision }),
				(draft, result) => cache.upsertVariable(draft, result.variable),
			),

		updateVariable: (
			variableId: string,
			patch: { type?: VariableType; defaultValue?: string | null; description?: string | null },
		) =>
			enqueue(
				"Не удалось сохранить переменную",
				(baseRevision) => api.updateVariable(scenarioId, variableId, { ...patch, baseRevision }),
				(draft, result) => cache.upsertVariable(draft, result.variable),
			),

		deleteVariable: (variableId: string) =>
			enqueue(
				"Не удалось удалить переменную",
				(baseRevision) => api.deleteVariable(scenarioId, variableId, baseRevision),
				(draft) => cache.removeVariable(draft, variableId),
			),
	}
}
